/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { createLaborCostLog } from '../fn/labor-cost-logs/create-labor-cost-log';
import { CreateLaborCostLog$Params } from '../fn/labor-cost-logs/create-labor-cost-log';
import { deleteLaborCostLog } from '../fn/labor-cost-logs/delete-labor-cost-log';
import { DeleteLaborCostLog$Params } from '../fn/labor-cost-logs/delete-labor-cost-log';
import { getLaborCostLog } from '../fn/labor-cost-logs/get-labor-cost-log';
import { GetLaborCostLog$Params } from '../fn/labor-cost-logs/get-labor-cost-log';
import { LaborCostLogDto } from '../models/labor-cost-log-dto';
import { LaborCostLogDtoPage } from '../models/labor-cost-log-dto-page';
import { listLaborCostLogs } from '../fn/labor-cost-logs/list-labor-cost-logs';
import { ListLaborCostLogs$Params } from '../fn/labor-cost-logs/list-labor-cost-logs';
import { updateLaborCostLog } from '../fn/labor-cost-logs/update-labor-cost-log';
import { UpdateLaborCostLog$Params } from '../fn/labor-cost-logs/update-labor-cost-log';

@Injectable({ providedIn: 'root' })
export class LaborCostLogsApi extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `listLaborCostLogs()` */
  static readonly ListLaborCostLogsPath = '/v0/laborCostLogs';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listLaborCostLogs()` instead.
   *
   * This method doesn't expect any request body.
   */
  listLaborCostLogs$Response(params?: ListLaborCostLogs$Params, context?: HttpContext): Observable<StrictHttpResponse<LaborCostLogDtoPage>> {
    return listLaborCostLogs(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listLaborCostLogs$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listLaborCostLogs(params?: ListLaborCostLogs$Params, context?: HttpContext): Observable<LaborCostLogDtoPage> {
    return this.listLaborCostLogs$Response(params, context).pipe(
      map((r: StrictHttpResponse<LaborCostLogDtoPage>): LaborCostLogDtoPage => r.body)
    );
  }

  /** Path part for operation `getLaborCostLog()` */
  static readonly GetLaborCostLogPath = '/v0/laborCostLogs/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getLaborCostLog()` instead.
   *
   * This method doesn't expect any request body.
   */
  getLaborCostLog$Response(params: GetLaborCostLog$Params, context?: HttpContext): Observable<StrictHttpResponse<LaborCostLogDto>> {
    return getLaborCostLog(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getLaborCostLog$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getLaborCostLog(params: GetLaborCostLog$Params, context?: HttpContext): Observable<LaborCostLogDto> {
    return this.getLaborCostLog$Response(params, context).pipe(
      map((r: StrictHttpResponse<LaborCostLogDto>): LaborCostLogDto => r.body)
    );
  }

  /** Path part for operation `updateLaborCostLog()` */
  static readonly UpdateLaborCostLogPath = '/v0/laborCostLogs/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateLaborCostLog()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateLaborCostLog$Response(params: UpdateLaborCostLog$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return updateLaborCostLog(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateLaborCostLog$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateLaborCostLog(params: UpdateLaborCostLog$Params, context?: HttpContext): Observable<void> {
    return this.updateLaborCostLog$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `createLaborCostLog()` */
  static readonly CreateLaborCostLogPath = '/v0/laborCostLogs/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createLaborCostLog()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createLaborCostLog$Response(params: CreateLaborCostLog$Params, context?: HttpContext): Observable<StrictHttpResponse<LaborCostLogDto>> {
    return createLaborCostLog(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createLaborCostLog$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createLaborCostLog(params: CreateLaborCostLog$Params, context?: HttpContext): Observable<LaborCostLogDto> {
    return this.createLaborCostLog$Response(params, context).pipe(
      map((r: StrictHttpResponse<LaborCostLogDto>): LaborCostLogDto => r.body)
    );
  }

  /** Path part for operation `deleteLaborCostLog()` */
  static readonly DeleteLaborCostLogPath = '/v0/laborCostLogs/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteLaborCostLog()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteLaborCostLog$Response(params: DeleteLaborCostLog$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return deleteLaborCostLog(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteLaborCostLog$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteLaborCostLog(params: DeleteLaborCostLog$Params, context?: HttpContext): Observable<void> {
    return this.deleteLaborCostLog$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
